<template>
  <div>
    <input :disabled="disabled" type="file" style="display: none;" ref="fileRef" id="file" accept="image/png,image/gif,image/jpeg">
    <div class="img-list">
      <el-image-viewer  v-if="data.showImgUrl" :url-list="[data.showImgUrl]"  @close="imgCloseBtn"/>
      <div class="img-box slide-in-blurred-top" :style="{'width':(parseInt(width) - 8)+'px','height':(parseInt(height) - 8)+'px'}" v-for="(item,index) in data.FileList" :key="index">
        <el-image ref="imageRef"  style="width: 100%;height:100%;border-radius:4px;box-shadow:0 0 2px rgba(180, 180, 180, 0.6);"   :src="item.url" fit="cover" />
        <div class="img-model">
          <div class="img-model-item">
              <!-- <el-icon class="item-icon"><ZoomIn /></el-icon> -->
              <!-- <i  @click="previewBtn(item.url)" class="el-icon-zoom-in item-icon"></i> -->
              <i v-show="!disabled" @click="removeBtn(index,$event)" style="cursor:pointer;" class="el-icon-delete item-icon"></i>
              <!-- <el-icon  class="img-icon" "><Delete /></el-icon> -->
          </div>
        </div>
      </div>
      <div v-if="data.FileList.length != limit" @click="fileUploadBtn" class="ing-add" :style="{'width':width,'height':height}">
          <!-- <el-icon style="font-size:20px;color:#858585;"><Plus /></el-icon> -->
          <img class="img" src="@/assets/shancghau.png" alt="">
      </div>
    </div>
  </div>
</template>
<script>
import { popSFun, popWFun } from "@/utils/utils";

export default {
  props:{
    keyName:{
      type:String,
      default:()=>'default'
    },
    param:{
        type:Object,
        default:()=>{}
    },
    width:{
      type:[String,Number],
      default:()=>'100px'
    },
    height: { 
      type:[String,Number],
      default:()=>'100px'
    },
    action:{
        type:String,
        default:()=>''
    },
    limit:{
        type:Number,
        default:()=>1
    },
    beForeUFun:{
        type:Function,
        default:(file,param,resolve,reject)=>resolve(true)
    },
    showAction:{
      type: String,
      default:() => ''
    },
    disabled:{
      type:Boolean,
      default:() => false
    }
  },
  components:{
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  data(){
    return { 
      data:{
        header:{'Authorization':localStorage.getItem("OPERATE_SYS_TOKERNDISTRIBUTION")},
        FileList:[
          // {
          //   name:'1',
          //   url:'http://api.yujn.cn/api/baisi.php'
          // }
        ],
        blockShow:false,
        showImgUrl:""
      }
    }
  },
  mounted(){
    console.log()
    this.$refs.fileRef.onchange = async (e)=>{
      this.fileChange(e);
    }
  },
  methods:{
      // 点击文件上传
      async fileUploadBtn(){

        this.$refs.fileRef.click();

        this.$refs.fileRef.onchange = async (e)=>{
          console.log(e.target.files[0])
          let isUpload = await this.beUploadBtn(e.target.files[0]);
          if(!isUpload)return;

          // 创建一个读取流
          const reader = new FileReader();
          reader.readAsDataURL(e.target.files[0]);
          reader.onload = (e)=>{
            this.data.FileList.push({
              name:window.crypto.getRandomValues(new Uint8Array(12)).toString(),
              url:e.target.result
            })
            this.getVal()
          }

          let formData = new FormData();
          formData.append("file",e.target.files[0])
          console.log(this);
          Object.keys(this.param || {}).forEach((key)=>{
            formData.append(key,this.param[key]);
          })

          this.$refs.fileRef.value = "";


          // 图片上传请求
          // const xhr = new XMLHttpRequest();
          // xhr.open("POST",this.action);
          // xhr.setRequestHeader("Authorization",localStorage.getItem("OPERATE_SYS_TOKERNDISTRIBUTION"));
          // xhr.send(formData);
          // xhr.onreadystatechange = ()=>{
          //   if(xhr.readyState == 4 && xhr.status == 200){
          //     let res = JSON.parse(xhr.responseText);
          //     if(res.code == 1){
          //     this.data.FileList[this.data.FileList.length-1].response = {
          //       data:res.data
          //     }
          //     this.$refs.fileRef.value = "";
          //     this.getVal()
          //     }else{
          //       popWFun(res.exceptionMsg);
          //       this.data.FileList.splice(this.data.FileList.length-1,1)
          //     }
          //   }
          // }
          // xhr.onprogress = (e)=>{
          //   console.log('上传进度',e)
          //   const progress = e.loaded / e.total;
          //   // progressBar.style.width = `${progress * 100}%`;
          //   // progressBar.textContent = `${Math.round(progress * 100)}%`;
          // }
        }

      },
      async fileChange(e){
        let isUpload = await beUploadBtn(e.target.files[0]);
        if(!isUpload)return;

        // 创建一个读取流
        const reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (e)=>{
          this.data.FileList.push({
            name:window.crypto.getRandomValues(new Uint8Array(12)).toString(),
            url:e.target.result
          })
          this.getVal()
        }

        let formData = new FormData();
        formData.append("file",e.target.files[0]);
        Object.keys(this.param || {}).forEach((key)=>{
          formData.append(key,this.param[key]);
        })

        this.$refs.fileRef.value = "";

        // // 图片上传请求
        // const xhr = new XMLHttpRequest();
        // xhr.open("POST",this.action);
        // xhr.setRequestHeader("Authorization",localStorage.getItem("OPERATE_SYS_TOKERNDISTRIBUTION"));
        // xhr.send(formData);
        // xhr.onreadystatechange = ()=>{
        //   if(xhr.readyState == 4 && xhr.status == 200){
        //     let res = JSON.parse(xhr.responseText);
        //     if(res.code == 1){
        //     this.data.FileList[this.data.FileList.length-1].response = {
        //       data:res.data
        //     }
        //     this.$refs.fileRef.value = "";
        //     this.getVal()
        //     }else{
        //       popWFun(res.exceptionMsg);
        //       this.data.FileList.splice(this.data.FileList.length-1,1)
        //     }
        //   }
        // }
        // xhr.onprogress = (e)=>{
        //   console.log('上传进度',e)
        //   const progress = e.loaded / e.total;
        //   // progressBar.style.width = `${progress * 100}%`;
        //   // progressBar.textContent = `${Math.round(progress * 100)}%`;
        // }
      },
      // 图片上传之前
      async beUploadBtn(file){

        //判断文件类型
        if(!(file.type == "image/jpeg" || file.type == "image/png")){
            popWFun("上传图片只能是 JPG、PNG 格式!");
            return false;
        }

        //判断文件大小 不能超过5mb
        if(file.size > (1024*1024*5)){
            popWFun("上传图片大小不能超过 5MB!");
            return false;
        }

        return await new Promise((resolve,reject) =>{
            this.beForeUFun(file,this.param,resolve,reject);
        })
      },
      // 关闭图片浏览
      imgCloseBtn(){
        console.log('关闭图片浏览')
        this.data.showImgUrl = ''
      },
      //移除图片
      removeBtn(index,event){
          let div = event.target.parentNode.parentNode.parentNode;

          console.log(div,'---')

          const getParent = (el)=>{
            if(el == null || el == undefined)return;
            if(el.className != undefined && el.className.indexOf('img-box') > -1){
              el.classList.add('slide-out-top');
              return;
            }else if (el.className != undefined && el.className.indexOf('img-list') > -1){
              getParent(el.children[index])
            }else { 
              getParent(el['parentNode'])
            }
          }
          getParent(div);
          setTimeout(()=>{
              this.data.FileList.splice(index,1);
              this.getVal()
          },100)
      },
      //预览
      previewBtn(imgSrc){
        this.data.showImgUrl = imgSrc;
      },
      //获取文件
      getVal(){
        let list = this.data.FileList
        let valA = []
        let valB = []
        let valC = []
        for(let i = 0;i<list.length;i++){
          if(!!list[i].response){
            valA.push({name:list[i].response.data,url:list[i].url})
            valB.push(list[i].response.data)
            valC.push(list[i].url)
          }else{
            valA.push({name:list[i].name,url:list[i].url})
            valB.push(list[i].name)
            valC.push(list[i].url)
          }
        }
        let parms = {
            valA:valA,
            valB:valB,
            valC:valC,
            valD:valB.join(),
            valE:valC.join(),
        }
        this.$emit("getVal",{...parms,keyName:this.keyName})
      },
      //设置回显数据 回显数据格式[{name:"",url:""}]
      setValFun(ev){
        this.data.FileList = ev
        nextTick(()=>{
            this.getVal()
        })
      },

      //通过请求获取图片但单个
      httpImgFun(ev){
        fetch(this.showAction+"?objectName="+ev,{
              method:'GET',
              headers:{'Authorization':localStorage.getItem("OPERATE_SYS_TOKERNDISTRIBUTION")},
          }).then(res=>res.json()).then(res => {
            if(res.code==1){
                this.data.FileList = [{name:ev,url:res.data}] 
                nextTick(()=>{
                  this.getVal()
                })
            }else{
                popWFun("获取数据失败")
            }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
.img-list{
  display: flex;
  flex-wrap: wrap;
  .img-box{
    margin-right: 10px;
    margin-bottom: 10px;
    position: relative;
  }
  img{
    border-radius: 4px;
  }
}
.slide-in-blurred-top {
  animation: slide-in-blurred-top 0.6s cubic-bezier(0.230, 1.000, 0.320, 1.000) both;
}
@keyframes slide-in-blurred-top {
  0% {
    transform: translateY(-100px) scaleY(2.5) scaleX(0.2);
    transform-origin: 50% 0%;
    filter: blur(40px);
    opacity: 0;
  }
  100% {
    transform: translateY(0) scaleY(1) scaleX(1);
    transform-origin: 50% 50%;
    filter: blur(0);
    opacity: 1;
  }
}

.slide-out-top {
  animation: slide-out-top 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
}
@keyframes slide-out-top {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(-1000px);
    opacity: 0;
  }
}
.item-icon{
  color: aliceblue;
  font-size: 20px;
  cursor: pointer;
  margin-right:10px;
  position: relative;
  top:2px;
}
.img-model{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius:4px;
  position: absolute;
  opacity: 0;
  transition: all .5s;
  background-color: rgba(0, 0, 0, 0.3);
  .img-model-item{
    padding-top:6%;
    padding:5% 10px 0 10px;
  }
}
.img-box:hover .img-model{
  opacity: 1;
}
.img-box:hover .img-icon{
  opacity: 1;
}
.img-icon{
  opacity: 1;
  font-size:18px;
  color: white;
  transition: all 0.3s;
}
.ing-add{
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
</style>